import React from 'react';
import { useI18next } from 'gatsby-plugin-react-i18next';

export const LanguageBlock = ({
  language,
  listening,
  understandingWriting,
  interacting,
  production,
  writing,
  extra = null,
}) => {
  const { t } = useI18next();

  return (
    <div className="language-block p-4 mb-4 bg-dark-green text-white">
      <h3>{language}</h3>
      {extra && <span className="my-4">{extra}</span>}
      <div className="mt-4 mb-2 text-uppercase fw-bold">{t('g.understanding')}</div>
      <span className="me-4">
        {t('g.listening')}: {listening}
      </span>
      <span>
        {t('g.reading')}: {understandingWriting}
      </span>
      <div className="mt-4 mb-2 text-uppercase fw-bold">{t('g.speaking')}</div>
      <div>
        {t('g.interaction')}: {interacting}
      </div>
      <div>
        {t('g.production')}: {production}
      </div>
      <div className="mt-4 mb-2 text-uppercase fw-bold">{t('g.writing')}</div>
      <div>
        {t('g.writing')}: {writing}
      </div>
    </div>
  );
};
